import enLang from "./entries/en-US";
import zhLang from "./entries/zh-Hans-CN";
import itLang from "./entries/it_IT";
import esLang from "./entries/es_ES";
import frLang from "./entries/fr_FR";
import jaLang from "./entries/ja_JP";
import heLang from "./entries/he_IL";
import deLang from "./entries/de_DE";
import arLang from "./entries/ar_SA";
import koLang from "./entries/ko_KR";
import viLang from "./entries/vi_VN";
import thLang from "./entries/th_TH";
import ruLang from "./entries/ru_RU";

import { addLocaleData } from "react-intl";

const AppLocale = {
  en: enLang,
  zh: zhLang,
  it: itLang,
  es: esLang,
  fr: frLang,
  ja: jaLang,
  he: heLang,
  de: deLang,
  ar: arLang,
  ko: koLang,
  vi: viLang,
  th: thLang,
  ru: ruLang,
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.zh.data);
addLocaleData(AppLocale.it.data);
addLocaleData(AppLocale.es.data);
addLocaleData(AppLocale.fr.data);
addLocaleData(AppLocale.ja.data);
addLocaleData(AppLocale.he.data);
addLocaleData(AppLocale.de.data);
addLocaleData(AppLocale.ar.data);
addLocaleData(AppLocale.ko.data);
addLocaleData(AppLocale.vi.data);
addLocaleData(AppLocale.th.data);
addLocaleData(AppLocale.ru.data);

export default AppLocale;
